import axios from 'axios';
import envs from 'envs';

import { isFilledQueryValue } from './queryValues';
import sessionToken from './sessionToken';

const api = axios.create({
  baseURL: `${envs.PROTOCOL}://${envs.ENTRYPOINT}/api`,
  withCredentials: true,
});

const withoutEmptyQueryParams = url => {
  const [path, search] = (url || '').split('?');
  if (!search) return path;

  const filled = new URLSearchParams();
  new URLSearchParams(search).forEach((value, key) => {
    if (isFilledQueryValue(value) && value !== 'undefined' && value !== 'null') {
      filled.append(key, value);
    }
  });

  const filledSearch = filled.toString();
  return filledSearch ? `${path}?${filledSearch}` : path;
};

api.interceptors.request.use(
  config => {
    config.url = withoutEmptyQueryParams(config.url); //eslint-disable-line

    const { token, expiry } = sessionToken();
    const { Authorization } = config.headers;

    if (expiry) {
      const expiryDate = new Date(expiry);
      const nowDate = new Date();
      const isExpired = nowDate.getTime() > expiryDate.getTime();

      if (isExpired) {
        sessionToken({ destroy: true });

        return config;
      }
    }

    if (token && !Authorization) {
      config.headers.Authorization = `Token ${token}`; //eslint-disable-line
    }

    return config;
  },
  error => Promise.reject(error),
);

api.interceptors.response.use(
  response => response,
  error => {
    if (error.response?.status === 401 && error.response?.data?.detail === 'Token inválido.') {
      sessionToken({ destroy: true });
    }
    return Promise.reject(error);
  },
);

export default api;
